import React, { useState } from 'react';
import { translate } from '../../services/translate';
import MyDropDownPicker from '../../components/MyDropDownPicker';
import BasicModal from '../../components/BasicModal';


interface ModalProps {
    isModalVisible: boolean;
    setModalVisible: (value: boolean) => void;
    onSubmit: (timelineProviderId: number) => Promise<void>;
    availableTimelineProviders: { id: number; name: string; }[];
}

export default function UpdateTimelineProviderModal({
    isModalVisible,
    setModalVisible,
    onSubmit,
    availableTimelineProviders,
}: ModalProps) {

    const [timelineProviderDropdownOpen, setTimelineProviderDropdownOpen] = useState(false);
    const [timelineProviderId, setTimelineProviderId] = useState<number | null>(null);

    return (
        <BasicModal
            isModalVisible={isModalVisible}
            setModalVisible={setModalVisible}
            title={translate('selectTimelineProvider')}
            width='small'
            mobileHeight='fill'
            primaryButton={{
                text: translate('confirm'),
                onClick: async () => {
                    if (!timelineProviderId) {
                        return;
                    }
                    await onSubmit(timelineProviderId);
                },
                disabled: !timelineProviderId,
            }}
            disableScrollView={true}
        >
            <MyDropDownPicker
                placeholder={translate('timelineProviders')}
                searchable={true}
                items={[{}, ...availableTimelineProviders.map(tp => ({
                    value: tp.id,
                    label: tp.name,
                }))]}
                open={timelineProviderDropdownOpen}
                setOpen={setTimelineProviderDropdownOpen}
                setValue={setTimelineProviderId}
                value={timelineProviderId}
                zIndex={3}
            />
        </BasicModal>
    );
}
